var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"loader"},[_c('n-icon',_vm._b({staticClass:"spinner",style:({ animation: `spin ${_vm.speed}s linear infinite` }),attrs:{"name":"loading","color":_vm.color}},'n-icon',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }